export default __webpack_public_path__ + "static/services-2e703a5a20a2c2b9b264c631b1e70fef.png";